import React from "react";
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa6";
import "./FooterPage.css";
import Logo from "../Assets/logos/logo.png";

const FooterPage = () => {

  const year = new Date().getFullYear();

  return (
    <footer className="footer">

      <div className="footer-container">

        {/* Brand */}
        <div className="footer-brand">

          <img
            src={Logo}
            alt="Ripple Run Logo"
            className="footer-logo"
          />

          <p className="footer-tagline">
            Running together to protect water, protect life,
            and protect our future.
          </p>

        </div>


        {/* Important Links */}
        <div className="footer-links">

          <h4>Important Links</h4>

         <a href="https://www.unichemghana.com" target="_blank" rel="noopener noreferrer">
        Unichem Ghana Group
      </a>

      <a href="https://www.luexhealthcare.com" target="_blank" rel="noopener noreferrer">
        Luex Healthcare
      </a>
          

        </div>


        {/* Contact */}
        <div className="footer-contact">

          <h4>Contact</h4>

          <p>Email: customerservice@unichemghana.com</p>
          <p>Phone: +233 531 065 015 / +233 302 739 009</p>
          <p>Accra, Ghana</p>

        </div>


        {/* Social */}
        <div className="footer-social">

          <h4>Follow Us</h4>

          <div className="social-icons">

             <a
       href="https://www.facebook.com/ripplerunmarathon?ref=1&_rdc=1&_rdr#" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
     <FaFacebookF />
     </a>

        <a
          href="https://youtube.com/@luexhealthcare?si=8IdkgwwxyYURNfBc"
          aria-label="YouTube"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaYoutube />
        </a>

        <a
          href="https://www.instagram.com/ripplerunmarathon/"
          aria-label="Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram />
        </a>
          </div>

        </div>

      </div>


      {/* Bottom Bar */}
      <div className="footer-bottom">

        <p className="footer-copy">
          © {year} Ripple Run. All Rights Reserved.
        </p>

       

      </div>

    </footer>
  );
};

export default FooterPage;